import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import PlainRadioInput from './PlainRadioInput';
import styles from './RadioButtons.css';
import getUniqueId from '../../../utils/getUniqueId';

const RadioButton = ({
    input,
    label,
    value,
    id = getUniqueId('radio-button'),
    span,
    className,
    color,
    checked,
}) => {
        const Label = input ? 'label' : 'div';
        const labelProps = input ? { htmlFor: `${id}-${value}` } : {};
        return (
            <div>
                <Label
                    className={cx(styles.label, className)}
                    {...labelProps}
                >
                    <PlainRadioInput
                        id={id}
                        color={color}
                        {...(input ? { input, value } : { checked })}
                    />
                    {label}
                </Label>
                {span && (
                    <span className={styles.span}>
                        {span}
                    </span>
                )}
            </div>);
    };

RadioButton.propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    id: PropTypes.string,
    color: PropTypes.string,
    span: PropTypes.string,
    className: PropTypes.string,
    // 'checked' prop must be passed, if not using 'input'
    checked: PropTypes.bool,
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/RadioButtons/RadioButton.js